import { render, staticRenderFns } from "./FarmsList.vue?vue&type=template&id=2e5412a2&scoped=true&"
import script from "./FarmsList.vue?vue&type=script&lang=js&"
export * from "./FarmsList.vue?vue&type=script&lang=js&"
import style0 from "./FarmsList.vue?vue&type=style&index=0&id=2e5412a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5412a2",
  null
  
)

export default component.exports